"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentItem = void 0;
class CommentItem {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input._id || input.id;
        // delete input._id
        return this;
    }
}
exports.CommentItem = CommentItem;
